/**
 ******************************************************************************
 *** GALLERY ALBUM COMPONENT ***
 ******************************************************************************
 */

import isLoaded from 'imagesloaded';
import lightGallery from 'lightgallery';
import lgZoom from 'lightgallery/plugins/zoom';
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgShare from 'lightgallery/plugins/share';
import Masonry from 'masonry-layout';

const gallery = new Masonry('.c-gallery', {
  itemSelector: '.c-gallery__item',
  columnWidth: '.c-gallery__item',
  percentPosition: true
});

isLoaded('.c-gallery').on('progress', () => {
  gallery.layout();
});

lightGallery(document.querySelector('.c-gallery'), {
  plugins: [lgZoom, lgFullscreen, lgShare],
  speed: 500,
  selector: '.c-gallery__link',
  licenseKey: 'CF22BF34-61824523-ADA58179-FCA80111'
});
